module.exports = __webpack_public_path__ + "assets/align-right-active.362b6971.svg";